var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7585_83851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.33329C6.6665 7.89127 6.8421 7.46734 7.15466 7.15478C7.46722 6.84222 7.89114 6.66663 8.33317 6.66663H14.9998C15.4419 6.66663 15.8658 6.84222 16.1783 7.15478C16.4909 7.46734 16.6665 7.89127 16.6665 8.33329V15C16.6665 15.442 16.4909 15.8659 16.1783 16.1785C15.8658 16.491 15.4419 16.6666 14.9998 16.6666H8.33317C7.89114 16.6666 7.46722 16.491 7.15466 16.1785C6.8421 15.8659 6.6665 15.442 6.6665 15V8.33329Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.66671V5.00004C13.3335 4.55801 13.1579 4.13409 12.8453 3.82153C12.5328 3.50897 12.1089 3.33337 11.6668 3.33337H5.00016C4.55814 3.33337 4.13421 3.50897 3.82165 3.82153C3.50909 4.13409 3.3335 4.55801 3.3335 5.00004V11.6667C3.3335 12.1087 3.50909 12.5327 3.82165 12.8452C4.13421 13.1578 4.55814 13.3334 5.00016 13.3334H6.66683",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7585_83851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.335735a6c5f39a279cf8a5a5b6c88adf.svg";
export { ForwardRef as ReactComponent };